module.exports = __webpack_public_path__ + "img/Helm.66f668ed.svg";